import React, { useCallback } from "react";
import DadosClienteDefaultForm from "./DadosClienteDefaultForm";
import { useDispatch, useSelector } from "react-redux";
import { isEnviandoPreenchimentoCliente } from "../../../../selectors/clientes.selectors";
import { actions } from "../../../../actions/clientes.actions";
import {
  actions as routeActions,
  types as routes,
} from "../../../../actions/rotas.actions";
import { toast } from "react-toastify";
import { getEtapasAbertas } from "../../../../selectors/workflow.selectors";
import { getPreenchimentoCliente } from "../../../../selectors/clientes.selectors";

const DadosClienteDefaultFormConnected = ({ setStep }) => {
  const dispatch = useDispatch();
  const { cliente: clienteData, dominios, validacao } = useSelector(getPreenchimentoCliente);
  const sending = useSelector(isEnviandoPreenchimentoCliente);

  const cliente = {
    ...clienteData,
    fluxo: validacao.completa.cliente,
  };

  const handleGoBack = useCallback(() => {
    dispatch(
      routeActions.redirectTo(routes.DETALHES_CLIENTE, { id: cliente.id })
    );
  }, [dispatch, cliente]);

  const handleAcessarCliente = useCallback(
    (e) => {
      e.stopPropagation();
      setStep(1);
    },
    [setStep]
  );

  return (
    <DadosClienteDefaultForm
      cliente={cliente}
      sending={sending}
      dominios={dominios}
      handleGoBack={handleGoBack}
      handleAcessarCliente={handleAcessarCliente}
    />
  );
};

export default DadosClienteDefaultFormConnected;
